import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54df0be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-checkbox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "to-bottom-right" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["container", { 'display-error': _ctx.displayError }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["checkbox", { checked: _ctx.checked }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('check')))
      }, _hoisted_3, 2),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2)
  ]))
}